import PersonalData from "./PersonalData";
import AddressData from "./AddressData";
import { ContactData } from "./ContactInformation";
import { DisabilityData } from "./DisablilityData";

interface IProps {
  formik: any;
  setShowModal: (data: boolean) => void;
  setShowDocExists: (data: boolean) => void;
  setShowCode: (data: boolean) => void;
  setShowSaved: (data: boolean) => void;
  showErrorsInputs:boolean;
}

export const FirstStepForm = (props: IProps) => {
  const { formik } = props;
  return (
    <div className="step-form animate__animated animate__fadeIn container__form__postulate">
      <PersonalData
        formik={formik}
        setShowModal={props.setShowModal}
        setShowDocExists={props.setShowDocExists}
        setShowCode={props.setShowCode}
        setShowSaved={props.setShowSaved}
        showErrorsInputs={props.showErrorsInputs}
      />
      <AddressData formik={formik} showErrorsInputs={props.showErrorsInputs} />
      <ContactData formik={formik} showErrorsInputs={props.showErrorsInputs} />
      <DisabilityData formik={formik} showErrorsInputs={props.showErrorsInputs} />
    </div>
  );
};
